import React, {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "@reduxjs/toolkit";

import {loadAndUnloadArchivable} from "@/data/load_and_unload_archivable.js";
import {ActionsTile} from "@/library/controls/actions_tile.jsx";
import {SettingsTile} from "@/library/controls/settings_tile.jsx";
import {SettingToggleCheckbox} from "@/library/controls/setting_toggle_checkbox.jsx";
import {selectApplyCommon} from "@/data/select_apply_common.js";
import {selectAppSetting} from "@/data/preferences/select_app_setting.js";

import {ControlServerCard} from "./control_server_card.jsx";
import {ControlServerCardNew} from "./control_server_card_new.jsx";
import {ControlServerErrorBoundary} from "./control_server_error_boundary.jsx";
import {SettingToggleButton} from "@/library/controls/setting_toggle_button.jsx";

export function ControlServersPane() {
  const dispatch = useDispatch();
  const intl = useIntl();

  const selectIncludeArchived = selectAppSetting("operations.controlServers.includeArchived");
  const selectFilterArchived = createSelector(selectIncludeArchived, ia => !ia);
  const selectControlServers = selectApplyCommon("controlServer", selectFilterArchived);

  const controlServers = useSelector(selectControlServers);
  const includeArchived = useSelector(selectIncludeArchived);
  const sessions = useSelector(s => s.environmentSession);
  const showNewCardAlways = useSelector(selectAppSetting("operations.controlServers.showNewCardAlways"));
  const showNewCardOnce = useSelector(selectAppSetting("operations.controlServers.showNewCardOnce"));

  const showNewCard = showNewCardAlways || showNewCardOnce;

  useEffect(
    loadAndUnloadArchivable("ControlServer", dispatch, sessions, includeArchived),
    [includeArchived]
  );

  return (
    <div className="control-servers-pane pane focusable-collection">
      <div className="pane-top">
        <h1 className="control-servers-title pane-title">
          {intl.formatMessage({id: "operations.controlServers.title"})}
        </h1>
        <ActionsTile pane="operations.controlServers" className="pane-actions">
          {!showNewCardAlways && (
            <SettingToggleButton className="show-new-card-once" setting="showNewCardOnce"/>
          )}
        </ActionsTile>
        <SettingsTile pane="operations.controlServers">
          <SettingToggleCheckbox setting="includeArchived"/>
          <SettingToggleCheckbox setting="showNewCardAlways"/>
        </SettingsTile>
      </div>
      <div className="control-servers-list">
        {showNewCard && (
          <ControlServerCardNew/>
        )}
        {controlServers.map(controlServer => (
          <ControlServerErrorBoundary controlServer={controlServer} key={controlServer.id}>
            <ControlServerCard
              controlServer={controlServer}
              session={controlServer.session}
            />
          </ControlServerErrorBoundary>
        ))}
      </div>
    </div>
  );
}
